var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCruetlyFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_5345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 0H0V86H86V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9998 29.7C49.6998 31 40.5998 24.7 31.9998 29.2C33.0998 31.5 35.9998 32.9 38.5998 33.8C41.2998 34.7 45.6998 34.5 47.9998 35.6C49.0998 46 30.3998 30.3 19.9998 46.3C15.1998 53.6 19.2998 58.7 17.4998 64.9C14.8998 74.2 20.5998 74.1 26.0998 70.4C30.7998 73 31.2998 72.5 37.3998 72.5C41.2998 72.5 46.1998 73.2 49.7998 71.9C48.8998 68.4 46.8998 68.7 43.0998 67.9L48.6998 65C48.6998 65.1 51.1998 76.9 58.0998 71.4C57.0998 67.1 53.9998 70.9 55.4998 62.5C56.1998 58.6 58.7998 58.6 61.1998 55.6C64.4998 51.6 62.8998 49.9 63.4998 45.3C63.9998 42.2 66.8998 41.4 69.1998 38.6C68.5998 36.1 66.7998 33.8 65.0998 31.8C62.3998 28.6 62.2998 29 57.8998 27.9C56.5998 20.8 52.3998 14.7 46.7998 12.9C45.6998 26.4 50.1998 25 51.9998 29.7Z",
    fill: "#81061A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_5345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruetlyFree);
export default __webpack_public_path__ + "static/media/cruetlyFree.f716b0777f9f1a0c38cdc7a9be74f2f6.svg";
export { ForwardRef as ReactComponent };